<template>
  <div>
    <v-switch
      :label="
        contextWorkflowData.isCustomizedWorkflowEnabled ? $t('settings.workflow.customizedWorkflowEnabled') : $t('settings.workflow.customizedWorkflowDisabled')
      "
      v-model="contextWorkflowData.isCustomizedWorkflowEnabled"
    />

    <workflow-item :item.sync="contextWorkflowData.workflow" v-if="contextWorkflowData.isCustomizedWorkflowEnabled" />

    <v-select
      v-if="contextWorkflowData.isCustomizedWorkflowEnabled"
      :label="$t('settings.workflow.decisionAs')"
      :items="users"
      item-value="id"
      item-text="fullName"
      :rules="[v => (v !== null && v !== '') || $t('global.error.required')]"
      v-model="contextWorkflowData.signAs"
    />
  </div>
</template>

<script>
import WorkflowItem from "../WorkflowItem";
export default {
  name: "Workflow",
  props: {
    workflowData: {
      required: true,
      type: Object
    }
  },
  components: { WorkflowItem },
  watch: {
    "contextWorkflowData.isCustomizedWorkflowEnabled"(val) {
      if (val && this.contextWorkflowData.workflow == null) {
        this.contextWorkflowData.workflow = {
          type: "start",
          conditionalTrueResult: null
        };
      } else if (!val) {
        this.contextWorkflowData.workflow = null;
      }
    }
  },
  computed: {
    contextWorkflowData: {
      get() {
        return this.workflowData;
      },
      set(val) {
        this.$emit("update:workflowData", val);
      }
    },
    users() {
      return this.$store.state.Settings.workflowData.users;
    }
  }
};
</script>

<style scoped />
